/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';

import {AuthenticatedClassDirective} from './authenticated-class.directive';
import {AuthenticatedDirective} from './authenticated.directive';
import {AuthenticationGuard} from './authentication-guard';
import {AuthenticationService} from './authentication.service';
import {RolesService} from './roles/roles.service';
import {RouteGuard} from './roles/route-guard';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AuthenticatedClassDirective,
    AuthenticatedDirective
  ],
  exports: [
    AuthenticatedClassDirective,
    AuthenticatedDirective
  ]
})
export class AuthenticationModule {
  public static forRoot(): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        AuthenticationService,
        RolesService
      ]
    };
  }
}
